import { render, staticRenderFns } from "./Island.vue?vue&type=template&id=2e66192e&scoped=true&"
import script from "./Island.vue?vue&type=script&lang=js&"
export * from "./Island.vue?vue&type=script&lang=js&"
import style0 from "./Island.vue?vue&type=style&index=0&id=2e66192e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e66192e",
  null
  
)

export default component.exports